import { AppBar, Toolbar, Grid, IconButton, Button } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Menu } from '@mui/icons-material'
import AddIcon from '@mui/icons-material/Add'
import SearchRedirect from '../../molecules/SearchRedirect'
import { openPopup } from '../../../store/popupsSlice'
import { logout } from '../../../store/userSlice'
import { useSelector, useDispatch } from 'react-redux'
import { changeBurgerExpanded } from '../../../store/layoutSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsersMedical, faPowerOff } from '@fortawesome/pro-solid-svg-icons'
import DownloadIcon from '@mui/icons-material/Download'
import downloader from '../../../lib/downloader'
import logoRTG from '../../../images/logo_rtg_black.svg'
import logoRTGnd from '../../../images/logo_rtg_black_responsive.svg'
import { Link } from 'react-router-dom'
import axios from 'axios'

const useStyles = makeStyles((theme) => ({
  redIcon: {
    color: theme.palette.red.main,
    fontSize: '20px',
  },
  burgerIcon: {
    marginRight: theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    burgerIcon: {
      display: 'none',
    },
  },
}))

const Header = () => {
  const downloadPlanmeca = () => {
    axios
      .post('planmeca_romexis_viewer/download', null, {
        responseType: 'blob',
        headers: {
          Accept: '',
        },
      })
      .then((res) => {
        downloader({
          type: 'application/x-7z-compressed',
          data: res.data,
          name: `Planmeca_Romexis_Viewer.7z`,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const dispatch = useDispatch()
  const classes = useStyles()
  const mobileOpen = useSelector((state) => state.layout.burgerExpanded)
  const user = useSelector((state) => state.user.user)

  return (
    <AppBar position="sticky" color="transparent">
      <Toolbar>
        <Grid
          container
          alignItems="center"
          className="justify-between header-btn"
        >
          {user.role_id == 0 && (
            <>
              <Link
                to="/patients"
                className="hover:opacity-50 transition-all w-80 side_menu_patient_logo_nd:hidden"
              >
                <img src={logoRTG} alt="logo" />
              </Link>
              <Link
                to="/patients"
                className="hover:opacity-50 transition-all w-14 side_menu_patient_logo:hidden"
              >
                <img src={logoRTGnd} alt="logo" />
              </Link>
            </>
          )}
          <Grid item>
            <Grid container alignItems="center">
              {(user.role_id == 1 || user.role_id == 2) && (
                <>
                  <Grid item>
                    <IconButton
                      className={classes.burgerIcon}
                      color="primary"
                      onClick={() =>
                        dispatch(changeBurgerExpanded({ value: !mobileOpen }))
                      }
                      size="large"
                    >
                      <Menu />
                    </IconButton>
                  </Grid>
                  {user.role_id == 1 && (
                    <Grid item>
                      <SearchRedirect />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Grid>
          <Grid item sm></Grid>
          <Grid item className="flex items-center gap-4">
            {(user.role_id == 0 || user.role_id == 2) && (
              <Button
                startIcon={<DownloadIcon />}
                variant="contained"
                color="primary"
                onClick={downloadPlanmeca}
              >
                Pobierz program
              </Button>
            )}
            {user.role_id == 1 && (
              <Button
                className="sm_header_custom_w:hidden"
                startIcon={<FontAwesomeIcon icon={faUsersMedical} />}
                variant="contained"
                color="primary"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'PatientFactory',
                      title: 'Dodaj pacjenta',
                      level: 1,
                      key: 'patient-factory-popup',
                      maxWidth: 'sm',
                    })
                  )
                }
              >
                <p className="header_custom_w:hidden">Dodaj pacjenta</p>
              </Button>
            )}
            {user.role_id == 1 && (
              <Button
                className="sm_header_custom_w:hidden"
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={() =>
                  dispatch(
                    openPopup({
                      component: 'ContractFactory',
                      title: 'Dodaj zlecenie',
                      level: 1,
                      maxWidth: 'xl',
                      key: 'contract-factory-popup',
                    })
                  )
                }
              >
                <p className="header_custom_w:hidden">Dodaj zlecenie</p>
              </Button>
            )}
            <Grid item>
              <IconButton
                title="Wyloguj się"
                className={classes.redIcon}
                onClick={() => {
                  dispatch(logout())
                }}
                size="large"
              >
                {<FontAwesomeIcon icon={faPowerOff} />}
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default Header
